import {z} from "zod";

/**
 * Parses and normalizes a raw search param into a typed array.
 * Supports two formats:
 * - TanStack Router native: array (preferred)
 * - Legacy URL format: comma-separated string "a,b"
 */
export function zUrlArray<T extends z.ZodTypeAny>(baseSchema: T) {
  return z
    .preprocess((value) => {
      if (value == null || value === "") return undefined;
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        return value
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean);
      }

      return value;
    }, baseSchema)
    .catch(undefined as unknown as z.output<T>);
}

/**
 * Parses a number from a URL search param string.
 */
export function zUrlNumber<T extends z.ZodTypeAny>(baseSchema: T) {
  return z
    .preprocess((v) => (v !== undefined && v !== "" ? Number(v) : undefined), baseSchema)
    .catch(undefined as unknown as z.output<T>);
}

/**
 * Parses an ISO date string (YYYY-MM-DD) from a URL search param string.
 */
export function zUrlIsoDate<T extends z.ZodTypeAny>(baseSchema: T) {
  return z
    .preprocess((value) => {
      if (value == null || value === "") return undefined;

      return value;
    }, baseSchema)
    .catch(undefined as unknown as z.output<T>);
}
